module.exports = __webpack_public_path__ + "img/request_success.041bb00d.png";